// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__wAeB4","approved":"Status_approved__1-_mK","rejected":"Status_rejected__8idxe","expired":"Status_expired__3_qjo","label":"Status_label__3ah8a"};